import { createFileRoute } from "@tanstack/react-router";
import Inhouse from "@/pages/Inhouse";
import { buildBreadcrumbSchema, getBreadcrumbTrail, buildPageSchema, buildSeoHead, buildServiceSchema, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/inhouse")({
  head: () =>
    buildSeoHead(
      publicPageSeo.inhouse,
      [
        buildPageSchema(publicPageSeo.inhouse, "WebPage"),
        buildServiceSchema(publicPageSeo.inhouse, "Inhouse ekonomi och interim ekonomi", [
          "Interim ekonom",
          "Inhouse redovisning",
          "Controllerstöd",
          "Tillfällig resursförstärkning",
        ]),
        buildBreadcrumbSchema(getBreadcrumbTrail("/inhouse") ?? []),
      ],
    ),
  component: Inhouse,
});
